import styled from "styled-components";

const StyledOverlayContainer = styled.div`
  position: relative;
  top: 100%;
`;

const StyledOverlay = styled.div`
  position: absolute;
  left: 16px;
  bottom: 16px;
  display: block;
`;

const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .play-icon {
    height: 12px;
    margin: 0 auto;
  }
`;

const StyledIconContainer = styled.div`
  background: transparent;
  width: ${({ size }) => {
    if (size === "large") {
      return "50px";
    } else if (size === "medium") {
      return "40px";
    } else if (size === "small") {
      return "30px";
    }
  }};
  height: ${({ size }) => {
    if (size === "large") {
      return "50px";
    } else if (size === "medium") {
      return "40px";
    } else if (size === "small") {
      return "30px";
    }
  }};
  border: 1px solid #ffffff;
  display: flex;
  align-items: center;
`;

const StyledDuration = styled.div`
  color: #ffffff;
  font-size: 16px;
  line-height: 16px;
  font-weight: 500;
  font-family: "FuturaPT-Medium";
  letter-spacing: 0.1px;
  margin-left: 8px;
`;

export {
  StyledOverlayContainer,
  StyledOverlay,
  StyledButtonWrapper,
  StyledIconContainer,
  StyledDuration,
};
